import type { ReactNode } from 'react';
import { themeToCssVars } from '@/shared/theme/theme';
import type { ThemeTokens } from '@/shared/theme/theme.entity';
import { AristoLogo } from './AristoLogo';

/**
 * Casco visual das LPs: a raiz `.lp` com o tema, mais a barra de topo.
 *
 * **É aqui que o tema vira CSS.** Os tokens entram como variáveis no `style`
 * da raiz, e tudo em `styles/lp.css` lê delas — por isso qualquer peça da LP
 * precisa estar dentro deste casco. Um diálogo renderizado em portal fora dele
 * perderia as cores; quando houver um, ele recebe `themeToCssVars` também.
 */
export function LpShell({
  theme,
  headerRight,
  children,
}: {
  theme: ThemeTokens;
  /** O que vai à direita do header. Omitido deixa o lado vazio. */
  headerRight?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="lp" style={themeToCssVars(theme)}>
      <header className="topbar">
        <div className="wrap">
          <AristoLogo className="brand" />
          <div className="topbar-actions">{headerRight}</div>
        </div>
      </header>

      {children}
    </div>
  );
}

/** Rodapé do site, com a marca e o direito autoral. */
export function LpFooter() {
  return (
    <footer className="foot">
      <div className="wrap">
        <AristoLogo className="brand" />
        <small>
          © {new Date().getFullYear()} Aristo. Todos os direitos reservados.
        </small>
      </div>
    </footer>
  );
}
